export const iconFontAwesomeToggleMicrophone = (
	<i className="fa-solid fa-microphone"></i>
);
